import AmioHttpService from '@/services/amio/amio-http.service'

class EmailConfigService extends AmioHttpService {
  async get(botId) {
    try {
      const { data } = await this.requestGet(`bots/${botId}/bot-email-config`)
      return this._adaptData(data)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  async update(botId, emailTemplate) {
    try {
      const { data } = await this.requestPatch(`bots/${botId}/bot-email-config`, {
        email_template: emailTemplate
      })
      return this._adaptData(data)
    } catch (err) {
      throw this.handleError(err)
    }
  }

  _adaptData(data) {
    return {
      emailTemplate: data.email_template,
      botId: data.bot_id
    }
  }
}

export default new EmailConfigService()
